import $ from 'jquery';

export default function vimeoPlayList() {

  function init() {
    // const clientId = $('.vimeo').attr('data-vimeo-client-id'); solo per OAuth (backend)
    // const clientSecret = $('.vimeo').attr('data-vimeo-client-secret'); solo per OAuth (backend)
    const albumId   = $('.vimeo').attr('data-vimeo-album-id');
    const articleId = $('.vimeo').attr('data-vimeo-article-id');

    async function loadPlaylist() {
      const videoplayer = document.getElementById("videoplayer");
      const videolist = document.getElementById("videolist");
      const videotitle = document.getElementById("video-title");

      try {
        const response = await fetch(
          `/o/intranet8020/media-gallery/vimeo-playlist` +
          `?articleId=${encodeURIComponent(articleId)}&albumId=${encodeURIComponent(albumId)}`
        );

        if (response.status === 401) {
          throw new Error("Token non valido o accesso non autorizzato");
        }
        if (response.status === 404) {
          throw new Error("Album o utente non trovato");
        }
        if (!response.ok) {
          throw new Error("Errore generico nel caricamento della playlist");
        }

        const videos = await response.json();

        if (!videos || videos.length === 0) {
          throw new Error("Playlist vuota o non trovata");
        }

        videos.forEach((video, index) => {
          const { name, thumb, duration: rawDuration, embedSrc } = video;
          const duration = formatDuration(rawDuration);

          if (index === 0) {
            videotitle.textContent = name;
            videoplayer.innerHTML =
              `<iframe src="${embedSrc}" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
          }

          const item = document.createElement("div");
          item.classList.add("video-playlist__item");

          if (index === 0) {
            item.classList.add("active");
          }

          item.innerHTML = `
            <div class="video-playlist__thumb">
              <img src="${thumb}" class="video-playlist__thumb-img" />
            </div>
            <div class="video-playlist__info">
              <div class="video-playlist__title">${name}</div>
              <span class="video-playlist__duration">${duration}</span>
            </div>
          `;

          item.addEventListener("click", () => {
            videoplayer.innerHTML = `
              <iframe
                src="${embedSrc}&autoplay=1"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen>
              </iframe>
            `;

            videotitle.textContent = name;

            document
              .querySelectorAll(".video-playlist__item")
              .forEach(el => el.classList.remove("active"));

            item.classList.add("active");
          });
          videolist.appendChild(item);
        });
      } catch (error) {
        console.error("Errore caricamento playlist:", error);
        videoplayer.innerHTML = "";
        videolist.innerHTML = "";
        videotitle.textContent = error.message;
      }
    }

    function formatDuration(seconds) {
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      return `${m}:${s.toString().padStart(2, "0")}`;
    }

    loadPlaylist();
  }

  $(document).ready(function() {
    if ($('.vimeo').length > 0) {
      init();
    }
  });
}
